import AuthRegLayout from '@/apps/layout/components/AuthRegLayout'
import { SetPassword } from '@/apps/ResetPassword'
import React from 'react'

const ResetPasswordPage = (): React.ReactElement => {
  return (
    <AuthRegLayout>
      <SetPassword />
    </AuthRegLayout>
  )
}

export default ResetPasswordPage
